const DEFAULT_API_BASE = 'https://api.simplyforyou.business/api';

export function getApiBase(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (host.includes('simplyforyou.business')) {
      return 'https://api.simplyforyou.business/api';
    }
    if (host.includes('simplyforyou.online')) {
      return 'https://api.simplyforyou.online/api';
    }
    if (host === '159.198.36.186') {
      return 'http://159.198.36.186:8000/api';
    }
  }
  const raw = import.meta.env.VITE_BACKEND_URL as string | undefined;
  return (raw?.replace(/\/+$/, '') || DEFAULT_API_BASE).replace(/\/+$/, '');
}
